import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';
import {useQuery} from '@apollo/client';

import {GetVtdTunnel} from '@graphql/argosJob/query';
import {OutputTunnelPopupTable} from '@modules/events/components/OutputTunnelPopupTable';
import {VIDEO_MANAGEMENT_PLATFORM_LINK} from '@constants/variables';
import {TunnelStatus} from '@utils/tableHelpers';

export const OutputTunnel = ({tunnel}) => {
    const tunnelId = tunnel?.vtd_tunnel_id;
    const {data} = useQuery(GetVtdTunnel, {
        variables: {id: tunnelId},
        skip: !tunnelId,
        fetchPolicy: 'cache-first',
    });

    const isStarted = !!data?.vtdTunnel?.started;
    const client = tunnel?.client_product_third_party?.client_product?.client;

    return (
        <>
            <Popup
                className='--noPadding'
                content={
                    <OutputTunnelPopupTable
                        vtdTunnelName={data?.vtdTunnel?.name}
                        vtdTunnelId={data?.vtdTunnel?.id}
                        isStarted={isStarted}
                        clientId={client?.id}
                        clientName={client?.name}
                        thirdPartyClientTunnelId={tunnel?.id}
                    />
                }
                trigger={
                    <a
                        href={`${VIDEO_MANAGEMENT_PLATFORM_LINK}/tunneler3/tunnel/${tunnelId}`}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={e => e.stopPropagation()}
                    >
                        {tunnel?.name}
                    </a>
                }
                position='top center'
                flowing
                hoverable
            />
            <span className='tunnel-status-label'>
                <TunnelStatus isStarted={isStarted} />
            </span>
        </>
    );
};

OutputTunnel.propTypes = {
    tunnel: PropTypes.shape({
        id: PropTypes.string,
        vtd_tunnel_id: PropTypes.string,
        name: PropTypes.string,
        client_product_third_party: PropTypes.shape({
            client_product: PropTypes.shape({
                client: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
            }),
        }),
    }),
};
